<template>
  <div v-if="order && company" class="tw-mx-auto tw-px-4 tw-text-sm tw-w-full" style="max-width: 1200px;">
    <a
      class="tw-px-4 tw-py-2 tw-rounded tw-font-medium tw-bg-red-500 tw-text-white hover:tw-bg-red-600 print-button tw-float-right tw-ml-4"
      href="javascript:window.open('', '_self').close();"
      >Close</a
    >

    <a
      class="tw-px-4 tw-py-2 tw-rounded tw-font-medium tw-bg-blue-500 tw-text-white hover:tw-bg-blue-600 print-button tw-float-right tw-ml-4"
      href="javascript:window.print();"
      >Print</a
    >

    <div class="tw-float-left tw-mr-4 tw-mb-0 tw-w-1/2">
      <h3 class="tw-text-left tw-mb-0">
        {{ company ? company.name : '' }} - Order Cover Page
      </h3>
    </div>

    <div class="tw-float-right tw-ml-4 tw-text-gray-500 tw-text-xs">Printed on {{ today() }}</div>

    <table class="tw-w-full tw-mt-4" >
      <tbody>
        <td class="tw-w-1/3">
          <h2 class="tw-mt-2 tw-text-3xl">Order #{{ order.id }}</h2>
        </td>
        <td v-if="order.isExport">
          <!--prettyhtml-ignore-->
          <h2 class="tw-mt-1 tw-text-2xl"><strong>E</strong>{{ 'xport' }}</h2>
        </td>
        <!--prettyhtml-ignore-->
        <td v-else>
          <!--prettyhtml-ignore-->
          <h2 class="tw-mt-1 tw-text-2xl"><strong>I</strong>{{ 'mport' }}</h2>
        </td>
        <td>
          <h2 class="tw-mt-1 tw-text-2xl">
            {{ order.isExport ? 'BKG' : 'BOL' }}:
            {{
              order.billOfLading
                ? order.billOfLading.billOfLadingNumber
                : order.bookingNumber
            }}
          </h2>
        </td>
      </tbody>
    </table>

    <table class="tw-w-full tw-mt-4">
      <thead>
        <th class="no-bold">Pick-Up From</th>
        <th class="no-bold">Delivery To</th>
        <th class="no-bold">Bill to</th>
      </thead>
      <tbody>
        <td>
          <div class="tw-ml-2" v-if="order.pickUpLocation">
            <p
              class="tw-text-left tw-mb-0 tw-mt-0"
            >
              <strong>{{ order.pickUpLocation.name }}</strong>
            </p>
            <p
              class="tw-text-left tw-mb-0 tw-mt-0"
            >
              {{ addressLine2(order.pickUpLocation.address) }}
            </p>
            <p
              class="tw-text-left tw-mb-0 tw-mt-0"
            >
              {{ addressLine3(order.pickUpLocation.address) }}
            </p>
            <br />
            <br />
          </div>
        </td>
        <td v-if="order.receiver">
          <div class="tw-ml-2 tw-text-left">
            <p class="tw-m-0">
              <strong>{{ order.receiver.name }}</strong>
            </p>
            <p
              class="tw-m-0"
              v-if="
                order.receiver.deliveryAddress &&
                order.receiver.deliveryAddress.streetAddress
              "
            >
              {{ addressLine2(order.receiver.deliveryAddress) }}
            </p>
            <p class="tw-m-0">
              {{ addressLine3(order.receiver.deliveryAddress) }}
            </p>
            <div v-if="order.receivingContact">
              <p class="tw-mb-0 tw-mt-4">
                {{
                  order.receivingContact.phoneNumber
                    ? order.receivingContact.phoneNumber
                    : ''
                }}
              </p>
              <p class="tw-m-0">
                {{
                  order.receivingContact.name ? order.receivingContact.name : ''
                }}
              </p>
            </div>
            <div v-else>
              <br />
              <br />
              <br />
            </div>
          </div>
        </td>
        <td v-if="order.billTo">
          <div class="tw-ml-2 tw-text-left">
            <p class="tw-m-0">
              <strong>{{ order.billTo.name }}</strong>
            </p>
            <p
              class="tw-m-0"
              v-if="
                order.billTo.billingAddress &&
                order.billTo.billingAddress.streetAddress
              "
            >
              {{ addressLine2(order.billTo.billingAddress) }}
            </p>
            <p class="tw-m-0">
              {{ addressLine3(order.billTo.billingAddress) }}
            </p>
            <div v-if="order.billingContact">
              <p class="tw-mb-0 tw-mt-4">
                {{
                  order.billingContact.phoneNumber
                    ? order.billingContact.phoneNumber
                    : ''
                }}
              </p>
              <p class="tw-m-0">
                {{ order.billingContact.name ? order.billingContact.name : '' }}
              </p>
            </div>
            <div v-else>
              <br />
              <br />
              <br />
            </div>
          </div>
        </td>
      </tbody>
    </table>
    <table class="tw-w-full tw-mt-4 no-bold">
      <thead>
        <th class="no-bold">Shipline</th>
        <th class="no-bold">Vessel</th>
        <th class="no-bold">{{ order.isExport ? 'Vessel Cut-off' : 'ETA' }}</th>
      </thead>
      <tbody>
        <td>
          <h3 class="tw-m-0 tw-text-2xl">{{ order.shipLine }}</h3>
        </td>
        <td v-if="order.vesselName != 'Vessel Unknown'">
          <h3 class="tw-m-0 tw-text-2xl">{{ order.vesselName }}</h3>
        </td>
        <td v-else></td>
        <td>
          <h3 class="tw-m-0 tw-text-2xl">{{ formatVesselEtaDate(order.vesselEtaString) }}</h3>
        </td>
      </tbody>
    </table>

    <table class="tw-w-full tw-mt-4">
      <thead>
        <th class="no-bold">#</th>
        <th class="no-bold">Container #</th>
        <th class="tw-w-1/6 no-bold">Size</th>
        <th class="no-bold tw-w-1/6">Appt Date</th>
        <th class="no-bold tw-w-1/6">
          {{ order.isExport ? 'First Recv Day' : 'First Available Day' }}
        </th>
        <th class="no-bold tw-w-1/6">
          {{ order.isExport ? 'Last Recv Day' : 'Last Free Day' }}
        </th>
      </thead>
      <tbody
        v-for="(container, cntrIdx) in sortedContainers"
        :key="cntrIdx"
        class="tw-text-lg"
      >
        <tr>
          <td class="tw-whitespace-nowrap">{{ cntrIdx + 1 }}</td>
          <td v-if="container.containerId !== 'EXPUNDEF'">
            {{ container.containerId }}
          </td>
          <td v-else></td>
          <td class="tw-whitespace-nowrap tw-mt-1">
            {{ containerSizeTypeString(container.sizeType) }}
          </td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td colspan="5">
            <br />
            <br />
          </td>
        </tr>
      </tbody>
    </table>
    <br />
  </div>
  <div v-else class="tw-container tw-mx-auto tw-px-4 tw-text-sm"></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import moment from 'moment';

import OrderQuery from '../../gql/orders/printing/Order.gql';
import CompanyQuery from '../../gql/company/Company.gql';
import { dateMixin } from '../../utils/date';

export default defineComponent({
  name: 'PrintOrder',
  data() {
    return {
      id: (this as any).$route.params.id,
      company: null as any,
      order: null as any,
    };
  },
  computed: {
    customerAddress(): string {
      if ((this as any).order) {
        if ((this as any).order.customer) {
          return `${(this as any).order.customer.name}`;
        } else if ((this as any).order.receiver) {
          return `${(this as any).order.receiver.name}`;
        }
      }

      return '';
    },
    sortedContainers(): any[] {
      if (!(this as any).order.containers) {
        return [];
      }

      const results = [];

      (this as any).order.containers.forEach((element) => {
        results.push(element);
      });

      if ((this as any).order.isExport) {
        return results.sort((a, b) => a.id.localeCompare(b.id));
      } else {
        return results.sort((a, b) =>
          a.containerId.localeCompare(b.containerId),
        );
      }
    },
  },
  methods: {
    today() {
      return moment().format('MM/DD/YYYY');
    },
    formatVesselEtaDate(eta: any): Date | String {
      if (!eta || !eta.trim() || (typeof eta !== 'string' && !(eta instanceof Date))) return '';
      console.log('eta', eta);

      const strictFormats = [
        moment.ISO_8601,
        'MM/DD/YYYY',
        'MM/DD/YYYY HH:mm',
        'MM/DD/YYYY HH:mm:ss',
        'YYYY-MM-DD',
        'YYYY-MM-DD HH:mm',
        'YYYY-MM-DD HH:mm:ss',
      ];

      let mDate: any;
      if (eta instanceof Date) {
        mDate = moment(eta);
      } else {
        mDate = moment(eta, strictFormats, true);
        console.log('eta moment string', mDate.toDate());
      }
      
      if (!mDate.isValid()) {
        return '';
      }
      return mDate.format('MM/DD/YYYY');
    },
    containerSizeTypeString(sizeType) {
      switch (sizeType) {
        case '40DS':
          return "40' DS";
        case '40DH':
          return "40' HC";
        case '20DH':
          return "20' HC";
        case '20DS':
          return "20' DS";
        case '20RS':
          return "20' RS";
        case '40RS':
          return "40' RS";
        case '20RH':
          return "20' RH";
        case '40RH':
          return "40' RH";
        default:
          return '';
      }
    },
    addressLine2(address): string {
      let addressStr = '';
      if (address) {
        if (address.streetAddress) {
          addressStr += address.streetAddress + ', ';
        }
        if (address.suite) {
          addressStr += address.suite + ' ';
        }
      }

      return addressStr;
    },
    addressLine3(address): string {
      let addressStr = '';
      if (address) {
        if (address.city) {
          addressStr += address.city + ', ';
        }
        if (address.state) {
          addressStr += address.state + ' ';
        }
        if (address.zipCode) {
          addressStr += address.zipCode + ' ';
        }
      }

      return addressStr;
    },
  },
  apollo: {
    order: {
      query: OrderQuery,
      variables() {
        return {
          id: (this as any).id,
        };
      },
    },
    company: {
      query: CompanyQuery,
    },
  },
});
</script>

<style lang="scss" scoped>
table {
  border-collapse: collapse;
}
td {
  border: 1px solid black;
  border-collapse: collapse;
}

th.no-bold {
  font-weight: normal !important;
}

@media print {
  #printPageButton {
    display: none;
  }
  .print-button {
    display: none;
  }
}

th,
td {
  padding: 0px;
}

</style>
